import { getEase, Tween } from "@westpierstudio/luma/createjs";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Signal } from "type-signals";
import { AdvancedText } from "@westpierstudio/luma/utils/advancedtext";
import { Text } from "pixi.js";
import { minimumHeightSpecSelector } from "utils/Responsive";

class FreeSpinsPromptSignals {
    complete = new Signal();
}

export class FreeSpinsPrompt extends View {
    private text: Text | AdvancedText;
    signals = new FreeSpinsPromptSignals();

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, resources} = this.services;

        const spec = resources.getSpec(`freespinsprompt`);
        factory.applySpec(this, spec);

        this.text = factory.createText(resources.getMessage(`freeSpinsPrompt`), spec.prompttext, this);
        this.visible = false;

        this.resize();
        services.layout.onResize.add(()=>this.resize());
    }

    show(): void {

        this.services.playerInactivity.start();

        const {idleTime} = this.services.resources.getSetting(`freeSpinsPrompt`);

        Tween.get(this)
        .wait(idleTime)
        .call(() => {
            this.pulse();
        });

        this.visible = true;
    }

    hide(): void {

        Tween.removeTweens(this);
        Tween.removeTweens(this.text.scale);

        this.visible = false;

        this.signals.complete.dispatch();
    }

    override reset(): void {
        Tween.removeTweens(this);
        Tween.removeTweens(this.text.scale);

        this.visible = false;
    }

    private pulse(): void {

        const {scale, time, ease} = this.services.resources.getSetting(`freeSpinsPrompt`).pulse;

        Tween.get(this.text.scale)
        .to({x: scale, y: scale}, time/2, getEase(ease))
        .to({x: 1, y: 1}, time/2, getEase(ease))
        .call(() => {
            this.pulse();
        });
    }

    resize() {
        const spec = this.services.resources.getSpec(`freespinsprompt`);
        const portraitSpec = minimumHeightSpecSelector(this.services, spec.portrait);
        this.services.factory.applySpec(this, portraitSpec);
    }
}